// Global
export const ERROR = 'ERROR'
export const PENDING = 'PENDING'
export const FEEDBACK = 'FEEDBACK'
